import { SVGProps, Ref, forwardRef } from 'react';

export const EllipsisHorizontalOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M5 10c-1.5 0-2 1-2 2s.5 2 2 2 2-1 2-2-.5-2-2-2" fill="currentColor" />
                <path d="M12 10c-1.5 0-2 1-2 2s.5 2 2 2 2-1 2-2-.5-2-2-2" fill="currentColor" />
                <path d="M17 12c0-1 .5-2 2-2s2 1 2 2-.5 2-2 2-2-1-2-2" fill="currentColor" />
            </g>
        </svg>
    )
);
EllipsisHorizontalOutlinedSize24Glyph.displayName = 'EllipsisHorizontalOutlinedSize24Glyph';
